import { useEffect, useState } from 'react';
import { Badge, useToast } from '@chakra-ui/react';

const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
  }
};

export const DevSectionBadges = () => {
  const [sections, setSections] = useState<{id: string, top: number}[]>([]);
  const toast = useToast();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    const update = () => {
      const els = document.querySelectorAll('[id$="-section"]');
      setSections(Array.from(els).map(el => {
        const r = el.getBoundingClientRect();
        // Calculate position relative to document for absolute positioning
        return { id: el.id, top: r.top + window.scrollY + 8 };
      }));
    };
    update();
    // Only update on resize, not scroll (since we use absolute positioning)
    window.addEventListener('resize', update);
    // Also update after a short delay to handle dynamic content
    const timeout = setTimeout(update, 500);
    return () => {
      window.removeEventListener('resize', update);
      clearTimeout(timeout);
    };
  }, []);

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <>
      {sections.map(s => (
        <Badge
          key={s.id}
          position="absolute"
          top={s.top + 'px'}
          right="8px"
          zIndex={9999}
          colorScheme="purple"
          cursor="pointer"
          fontSize="xs"
          px={2}
          py={1}
          onClick={() => {
            copyToClipboard('#' + s.id);
            toast({
              title: 'Copied: #' + s.id,
              status: 'success',
              duration: 1500,
              position: 'bottom'
            });
          }}
          _hover={{ transform: 'scale(1.05)', bg: 'purple.500' }}
          borderRadius="md"
          boxShadow="md"
        >
          #{s.id}
        </Badge>
      ))}
    </>
  );
};
